
import { Route } from 'react-router-dom';

import RootRoute from '../RootRoute';
import Login from '../../features/auth/pages/LoginScreen';

const AuthRoutes = () => {
  return (
    <>
      <Route path="/" element={<RootRoute />} />
      <Route path="/Login" element={<Login />} />
    </>
  );
};

export default AuthRoutes;
